var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"attribute-pill mr-1 mb-1",style:({ backgroundColor: _vm.item.color })},[_vm._v(" "+_vm._s(_vm.item.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }